var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinitoBlackLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8C0 2.14903 2.14904 0 4.8 0H19.2C21.851 0 24 2.14903 24 4.8V19.2C24 21.851 21.851 24 19.2 24H4.8C2.14904 24 0 21.851 0 19.2V4.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50451 16.5045C10.9923 16.5045 13.009 14.4877 13.009 12C13.009 9.51221 10.9923 7.49548 8.50451 7.49548C6.01677 7.49548 4 9.51221 4 12C4 14.4877 6.01677 16.5045 8.50451 16.5045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6901 5V19C17.5568 19 20.6901 15.8667 20.6901 12C20.6901 8.13334 17.5568 5 13.6901 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinitoBlackLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/finito-black-logo.25839e59195ad03be78e10faee481d1d.svg";